<template>
    <section class="card card-dashboard">
        <div class="card-body" v-if="loader">
            <template>
                <vcl-table :rows="4" :columns="2"></vcl-table>
            </template>
        </div>
        <div class="card-body pb-0" v-show="!loader">
            
            <div class="row">
                <div class="col-12 text-right mb-2">
                    <el-button type="danger" size="mini" @click="exportInventeory('pdf')">
                        <i class="fa fa-file-pdf"></i> Exportar PDF
                    </el-button>
                    <el-button type="success" size="mini" @click="exportInventeory('xlsx')">
                        <i class="fa fa-file-excel"></i> Exportar Excel
                    </el-button>
                </div>
                <label>Productos por vencer
                <el-tooltip class="item" effect="dark" content="Aplica filtro por establecimiento" placement="top-start">
                        <i class="fa fa-info-circle"></i>
                    </el-tooltip>
                </label>

                    <div class="col-md-3">
                        <label class="control-label">Fecha inicio</label>
                        <el-date-picker v-model="date_start" type="date"
                                        @change="reloadProducts"
                                        value-format="yyyy-MM-dd" format="dd/MM/yyyy" :clearable="true"></el-date-picker>
                    </div>
                    <div class="col-md-3">
                        <label class="control-label">Fecha término</label>
                        <el-date-picker v-model="date_end" type="date"
                                        :picker-options="pickerOptionsDates"
                                        @change="reloadProducts"
                                        value-format="yyyy-MM-dd" format="dd/MM/yyyy" :clearable="true"></el-date-picker>
                    </div>
            </div>
        </div>

        <div class="card-body p-0" v-show="!loader">
            <inventory-data-table :resource="resource">
                <tr slot="heading">
                    <th>#</th>
                    <th >Código</th>
                    <th >Producto</th>
                    <th class="text-center">Stock</th>
                    <th>Lote</th>
                    <th>Precio</th>
                    <th>F. Vencim</th>
                    <th>Almacén</th>
                </tr>
                <tr slot-scope="{ index, row }">
                    <td>{{ index }}</td>
                    <td  >{{ row.internal_id }}</td>
                    <td  >{{ row.product }}</td>
                    <td class="text-center">{{ row.stock }}</td>
                    <td> {{ row.lot }} </td>
                    <td> {{ row.price }} </td>
                    <td> {{ row.date }} </td>
                    <td>{{ row.warehouse }} </td>

                </tr>
            </inventory-data-table>
        </div>
    </section>
</template>


<script>

    import InventoryDataTable from '../../components/InventoryDataTable.vue'
    import { VclTable } from 'vue-content-loading';

    export default {
        components: {InventoryDataTable, VclTable},
        props: ['establishment'],
        data () {
            return {
                loader: true,
                resource: 'dashboard/product-of-due',
                records: [],
                date_start: moment().startOf("month").format("YYYY-MM-DD"),
                date_end: moment().endOf("month").format("YYYY-MM-DD"),
            }
        },
        watch: {
            establishment: {
                immediate: true,
                handler(newVal) {
                    if (newVal) {
                        // Solo emitir eventos cuando tenemos establishment_id
                        this.$eventHub.$emit('reloadSimpleDataTable', newVal)
                        this.$eventHub.$emit('reloadSimpleDate', this.date_start, this.date_end)
                    }
                }
            }
        },
        mounted(){
            this.events()
            if (this.establishment) {
                this.$eventHub.$emit('reloadSimpleDataTable', this.establishment)
                this.$eventHub.$emit('reloadSimpleDate', this.date_start, this.date_end)
            }
        },
        created() {
            // this.events()
        },
        methods: {
            events(){
                this.$eventHub.$on('recordsSkeletonLoader', (status) => {
                    this.loader = status
                })

                this.$eventHub.$on('changeStock', (establishment_id) => {
                    this.$eventHub.$emit('reloadSimpleDataTable', establishment_id)
                    // console.log(establishment_id)
                    this.$eventHub.$emit('reloadSimpleDate', this.date_start,this.date_end)
                })

            },

            async exportInventeory(type) {
                const params = {
                    establishment_id: this.establishment,
                    date_start: this.date_start,
                    date_end: this.date_end,
                    type
                }
                // const query = new URLSearchParams(params).toString()
                // const url = `/dashboard/exports/product-of-due/${type}?${query}`
                // window.open(url, '_blank')

                try {
            
                    const response = await this.$http.post(`/dashboard/exports/product-of-due`, params)
                    console.log(response)
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                } catch (error) {
                    console.log(error)
                    this.$message.error(error.message)
                }

            },

            reloadProducts() {
                this.$eventHub.$emit('reloadExpiringProducts', this.date_start, this.date_end)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// modules/Dashboard/Resources/assets/js/views/partials/dashboard_inventory.vue